import { render, staticRenderFns } from "./UserSetup.vue?vue&type=template&id=a9780300&scoped=true&"
import script from "./UserSetup.vue?vue&type=script&lang=js&"
export * from "./UserSetup.vue?vue&type=script&lang=js&"
import style0 from "./UserSetup.vue?vue&type=style&index=0&id=a9780300&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9780300",
  null
  
)

export default component.exports